import * as React from 'react';
import { WritingExample } from '@magoosh/admin/writing_examples/types';
import WritingExampleDocument from '@magoosh/pages/writing_examples/show/document';
import { Field, Formik, FormikHelpers } from 'formik';
import { LinkButton, PrimaryButton } from '@magoosh/lib/button';
import { adminPaths } from 'config/path_helpers';
import Modal from '@magoosh/lib/modal';
import { Evaluation } from '@magoosh/gre/pages/essay_review/types';
import style from '../index/style.module.scss';
import AdminWritingExampleForm from '@magoosh/admin/writing_examples/index/form';
import EvaluationModal from '@magoosh/admin/writing_examples/show/evaluation_modal';
import EditWritingExampleModal from '@magoosh/admin/writing_examples/show/edit_writing_example_modal';

interface Props {
  writingExample: WritingExample;
}
const WritingExampleAdminShow: React.FC<Props> = (props: Props) => {
  const [showEvaluationModal, setShowEvaluationModal] = React.useState(false);
  const [showEditWritingExampleModal, setShowEditWritingExampleModal] = React.useState(false);
  const [writingExample, setWritingExample] = React.useState<WritingExample>(props.writingExample);

  const fetchWritingExample = () => {
    fetch(adminPaths.api.writingExample(props.writingExample.id))
      .then((response) => response.json())
      .then((response) => {
        setWritingExample(response);
      });
  };

  const onEvalFormSuccess = () => {
    setShowEvaluationModal(false);
    fetchWritingExample();
  };

  const onEvalModalClose = () => {
    setShowEvaluationModal(false);
  };

  const onEditWritingExampleFormSuccess = () => {
    setShowEditWritingExampleModal(false);
    fetchWritingExample();
  };

  const onEditWritingExampleModalClose = () => {
    setShowEditWritingExampleModal(false);
  };

  return (
    <>
      <div>
        <div className={style.adminInfo}>
          <div>
            <h2>Manage writing example: {writingExample.title}</h2>
            <h4>In Brandings:</h4>
            <p>{writingExample.brandings.map((branding) => branding.name).join(', ')}</p>
            <h4>Access Level:</h4>
            <p>{writingExample.accessLevel.name}</p>
            <div className="u-margin-B-xl">
              {writingExample.evaluation ? (
                <PrimaryButton onClick={() => setShowEvaluationModal(true)}>Edit Evaluation</PrimaryButton>
              ) : (
                <PrimaryButton onClick={() => setShowEvaluationModal(true)}>Create Evaluation</PrimaryButton>
              )}
              <PrimaryButton className="u-margin-H-m" onClick={() => setShowEditWritingExampleModal(true)}>
                Edit Writing Example
              </PrimaryButton>
              <a className="btn btn-default" href={adminPaths.writingExamples()}>
                Back to List
              </a>
            </div>
          </div>
        </div>
        <div>
          <WritingExampleDocument writingExample={writingExample} evaluation={writingExample.evaluation} />

          <EvaluationModal
            show={showEvaluationModal}
            evaluation={writingExample.evaluation}
            writingExampleId={writingExample.id}
            onFormSuccess={onEvalFormSuccess}
            onClose={onEvalModalClose}
          />
          <EditWritingExampleModal
            show={showEditWritingExampleModal}
            writingExample={writingExample}
            onFormSuccess={onEditWritingExampleFormSuccess}
            onClose={onEditWritingExampleModalClose}
          />
        </div>
      </div>
    </>
  );
};

export default WritingExampleAdminShow;
